// content/ecoBannerContent.ts
export const popupbannerDetails = {
    title: "Did You Know?",
    content: [
      "Every scroll, every post, every minute you spend online releases CO₂ into the atmosphere, adding to our planet's carbon footprint.",
      "But what if your digital life could reverse your carbon footprint?"
    ],
    buttonText: "Join us",
    closeButtonAriaLabel: "Close banner"
  };